<script>
/* eslint-disable vue/require-v-for-key */
import AutocompleteWithMap from "@/components/AutocompleteWithMap";
import Modal from "@/components/Modal";
import InputField from "@/components/forms/InputField.vue";
import Actions from "./Actions.vue";

export default {
    name: "SimpleEventVenues",
    components: {
        Modal,
        AutocompleteWithMap,
        InputField,
        Actions,
    },
    data() {
        return {
            venues: [],
            showActivityActionDropdown: [],
            showAddVenue: false,
            newVenues: [],

            showEditModal: false,
            editVenueIdx: null,
            modalVenue: {
                venueName: "",
                address1: "",
                address2: "",
                area: "",
                city: "",
                postcode: "",
                country: "",
            },

            errors: {
                venueName: "",
                address1: "",
                address2: "",
                area: "",
                city: "",
                postcode: "",
                country: "",
            },

            showRemoveVenue: false,
            removeVenueIdx: null,
            removeVenueModal: {
                venueName: "",
                area: "",
                listingsAmount: null,
            },
            disableButtons: false,

        };
    },
    methods: {

        prevStep() {
            this.$router.back();
        },

        submit() {
            this.$router.push({ name: "Add event to venue", params: { venueIdx: 0 } });
        },

        removeVenues() {
            this.venues.splice(this.removeVenueIdx, 1);

            this.$storage.setStorageSync("venues", this.venues);
            this.showRemoveVenue = false;
        },

        closeEditModal() {
            this.modalVenue = {
                venueName: "",
                address1: "",
                address2: "",
                area: "",
                city: "",
                postcode: "",
                country: "",
            };

            this.editVenueIdx = null;
            this.showEditModal = false;
        },

        toggleModal(idx, type) {
            if (type === "edit") {
                this.modalVenue = this.venues[idx];
                this.editVenueIdx = idx;
                this.showEditModal = true;

                // this.showActivityActionDropdown[idx] = !this.showActivityActionDropdown[idx]
            }

            if (type === "remove") {
                const venue = this.venues[idx];

                this.removeVenueModal.venueName = venue.venueName;
                this.removeVenueModal.area = venue.area;

                this.showRemoveVenue = true;
                this.removeVenueIdx = idx;

                // this.showActivityActionDropdown[idx] = !this.showActivityActionDropdown[idx]
            }
        },

        submitModal() {
            this.venues[this.editVenueIdx] = this.modalVenue;
            this.showEditModal = false;
            this.editVenueIdx = null;
        },

        toggleActivityActionDropdown(idx) {
            this.showActivityActionDropdown[idx] = !this.showActivityActionDropdown[idx];
        },

        clickOutside() {
            // eslint-disable-next-line no-unused-vars
            this.showActivityActionDropdown = this.showActivityActionDropdown.map((ad) => false);
        },

        addVenue(venue) {
            this.newVenues.push(venue);
        },

        pushNewVenue() {
            const allVenues = [...this.venues, ...this.newVenues];
            this.$storage.setStorageSync("venues", allVenues);
            this.venues = allVenues;
            this.showAddVenue = false;
        },

        closeModal() {
            this.newVenues = [];
            this.showAddVenue = false;
        },
    },
    mounted() {
        const venues = this.$storage.getStorageSync("venues") || [];
        // eslint-disable-next-line no-unused-vars
        this.showActivityActionDropdown = venues.map((el) => false);
        this.venues = venues || [];

        const params = new URLSearchParams(window.location.search);
        if (params.get("alreadySelectedVenueRedirectFiring") !== null) {
            this.disableButtons = true;
        }
    },
};
</script>

<template>
    <div class="mt-3 simple-event-container mx-auto">

        <div class="d-flex flex-row justify-content-between">
            <h2 class="mb-3" v-if="venues.length > 1">Your venues</h2>
            <h2 class="mb-3" v-else>Your venue</h2>
            <!--      <button @click="showAddVenue = true" class="ml-0 btn-new btn-new-outline align-self-center font-weight-bold">-->
            <!--        + Add venue-->
            <!--      </button>-->
        </div>
        <!--    @open-edit-venue-modal="showAddVenue = false"-->
        <!--    @submit-edit-venue-modal="showAddVenue = true"-->
        <Modal
            :show-modal="showAddVenue"
            :title="'<h5>Add new venue<h5>'"
            @submit-modal="pushNewVenue"
            @close-modal="closeModal"
        >
            <AutocompleteWithMap
                :venues="newVenues"
                @venue-added="addVenue"
                :hide-venues="newVenues.length <= 0"
                :hide-map="newVenues.length > 0"
            />
        </Modal>

        <div v-for="(venue, idx) in venues" class="mt-3 venue-item simple-event">
            <div class="d-flex flex-row justify-content-between w-100"
                 v-click-outside="clickOutside"
            >
                <div class="venue-info-block">
                    <div class="d-flex flex-row">
                        <div class="venue-info-title">{{ venue.venueName }}{{ ", " + venue.area }}</div>
                    </div>
                    <div class="mt-2 venue-info-address">{{ venue.address1 }}, {{ venue.city }}, {{
                        venue.postcode
                    }}
                    </div>
                </div>

                <div v-if="!disableButtons" class="d-flex flex-row cursor-pointer align-self-center action-text">
                    <router-link v-if="!disableButtons" class="ml-auto"
                                 :to="{name: 'Add event to venue',params: { venueIdx: idx }}">
                        Add events
                    </router-link>

                    <div class="ml-3 d-flex flex-row justify-content-center">
                        <div @click="toggleActivityActionDropdown(idx)"
                             class="dd-action ml-2">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M10 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 10 8.125C8.96447 8.125 8.125 8.96447 8.125 10C8.125 11.0355 8.96447 11.875 10 11.875Z"
                                    fill="black"/>
                                <path
                                    d="M10 18.125C11.0355 18.125 11.875 17.2855 11.875 16.25C11.875 15.2145 11.0355 14.375 10 14.375C8.96447 14.375 8.125 15.2145 8.125 16.25C8.125 17.2855 8.96447 18.125 10 18.125Z"
                                    fill="black"/>
                                <path
                                    d="M10 5.625C11.0355 5.625 11.875 4.78553 11.875 3.75C11.875 2.71447 11.0355 1.875 10 1.875C8.96447 1.875 8.125 2.71447 8.125 3.75C8.125 4.78553 8.96447 5.625 10 5.625Z"
                                    fill="black"/>
                            </svg>

                            <div
                                class="dd-action--dropdown"
                                :class="{'active': showActivityActionDropdown[idx]}">
                                <div @click="toggleModal(idx, 'edit')" class="action-item">Edit venue</div>
                                <div v-if="venues.length > 1" class="separator"></div>
                                <div
                                    v-if="venues.length > 1"
                                    @click="toggleModal(idx, 'remove')"
                                    class="action-item remove"
                                >Remove venue
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="disableButtons" class="mt-3">
            Loading ...
        </div>

        <Modal
            :show-modal="showEditModal"
            submit-btn-class="submit-btn"
            closeBtnClass="btn-new btn-new-outline px-4 py-3 ml-0 no-underline"
            :title="'<h2>Edit venue<h2>'"
            close-text="Back"
            submit-text="Save"
            @submit-modal="submitModal"
            @close-modal="closeEditModal"
        >
            <div class="mt-4 manual-address-container">
                <div class="mt-3 d-flex flex-column">
                    <InputField
                        labelText="Venue name"
                        placeholder="Enter a venue name"
                        :required="true"
                        v-model="modalVenue.venueName"
                        :value="modalVenue.venueName"
                        :error="errors.venueName"
                    />
                </div>
                <div class="mt-3 d-flex flex-column">
                    <InputField
                        labelText="Address line 1"
                        placeholder="Address line 1"
                        :maxlength="255"
                        :required="true"
                        v-model="modalVenue.address1"
                        :value="modalVenue.address1"
                        :error="errors.address1"
                    />
                </div>
                <div class="mt-3 d-flex flex-column">
                    <InputField
                        labelText="Area"
                        placeholder="Enter an area"
                        :required="true"
                        v-model="modalVenue.area"
                        :value="modalVenue.area"
                        :error="errors.area"
                        sub-label-text="Please enter an area name. This will help your customers
                            easily differentiate between multiple venues of your business."
                    />
                </div>
                <div class="mt-3 d-flex flex-column">
                    <InputField
                        labelText="Town/City"
                        placeholder="Enter a town/city"
                        :required="true"
                        v-model="modalVenue.city"
                        :value="modalVenue.city"
                        :error="errors.city"
                    />
                </div>
                <div class="mt-3 d-flex flex-column">
                    <InputField
                        labelText="Postcode"
                        placeholder="Enter a postcode"
                        :required="true"
                        v-model="modalVenue.postcode"
                        :value="modalVenue.postcode"
                        :error="errors.postcode"
                    />
                </div>
                <div class="mt-3 d-flex flex-column">
                    <InputField
                        labelText="Country"
                        placeholder="Enter country name"
                        :required="true"
                        v-model="modalVenue.country"
                        :value="modalVenue.country"
                        :error="errors.country"
                        :disabled="true"
                    />
                </div>
            </div>
        </Modal>

        <Modal
            :tile="'<h5>Remove venue</h5>'"
            :show-modal="showRemoveVenue"
            @submit-modal="removeVenues"
            @close-modal="showRemoveVenue = false"
            modal-dialog-class="modal-md"
        >
            Are you sure you want to remove the <b>{{ removeVenueModal.venueName }},
                {{ removeVenueModal.area }}</b> venue? This will delete [X] listings.
        </Modal>

        <Actions
            @prev="prevStep"
            @next="submit"
            :full-width="true"
            next-button-text="Add events"
            class="fixed-bottom"
            actions-styles="alt-bottom-actions"
            :disabled="disableButtons"
        />
    </div>
</template>

<style>
h2 {
    font-weight: bolder;
}

.action-text a {
    font-weight: 600 !important;
}

.action-item {
    font-weight: 600 !important;
}

.pac-container {
    z-index: 1100 !important;
    overflow: visible;
}
</style>
